var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-dialog',{ref:"layoutDialog",attrs:{"title":"Terms of Use","subtitle":"SPONTAY, LLC"}},[_c('div',{attrs:{"id":"policies","name":"termly-embed","data-id":"5deb2c8d-8d1c-440d-9bee-24678c8c905e","data-type":"iframe"}})])}
var staticRenderFns = []

export { render, staticRenderFns }